type SessionLock = { result: Promise<boolean>; finish: (owned: boolean) => void; release?: () => void };

export class HumanChatSessionLock {
  private readonly entries = new Map<string, SessionLock>();

  constructor(private readonly scope: string, private readonly manager: LockManager | undefined) {}

  acquire(sid: string): Promise<boolean> {
    if (!this.manager || typeof sid !== 'string' || !sid || sid.length > 200) return Promise.resolve(false);
    const existing = this.entries.get(sid);
    if (existing) return existing.result;
    let finish!: SessionLock['finish'];
    const result = new Promise<boolean>(resolve => { finish = resolve; });
    const entry: SessionLock = { result, finish };
    this.entries.set(sid, entry);
    const fail = () => {
      if (this.entries.get(sid) === entry) this.entries.delete(sid);
      finish(false);
    };
    try {
      void this.manager.request(`autoqm:human-chat:owner:v1:${JSON.stringify([this.scope, sid])}`,
        { mode: 'exclusive', ifAvailable: true }, lock => {
          if (!lock || this.entries.get(sid) !== entry) { fail(); return; }
          const held = new Promise<void>(resolve => { entry.release = resolve; });
          finish(true);
          return held;
        }).catch(fail);
    } catch { fail(); }
    return result;
  }

  release(): void {
    for (const entry of this.entries.values()) {
      entry.finish(false);
      entry.release?.();
    }
    this.entries.clear();
  }
}